import { supabase } from '@/lib/supabase/client'

export const createCheckoutSession = async (priceId: string) => {
  const { data, error } = await supabase.functions.invoke(
    'create-checkout-session',
    {
      body: { priceId },
    },
  )

  if (error) {
    console.error('Error creating checkout session:', error)
    throw new Error('Não foi possível iniciar o checkout.')
  }

  return data
}

export const getSubscription = async () => {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  if (!user) return null

  const { data, error } = await supabase
    .from('subscriptions')
    .select('*, prices(*, products(*))')
    .in('status', ['trialing', 'active'])
    .single()

  if (error && error.code !== 'PGRST116') {
    console.error('Error fetching subscription:', error)
    return null
  }

  return data
}

export const cancelSubscription = async () => {
  const { data, error } = await supabase.functions.invoke('cancel-subscription')

  if (error) {
    console.error('Error canceling subscription:', error)
    throw new Error('Não foi possível cancelar a assinatura.')
  }

  return data
}

export const resumeSubscription = async () => {
  const { data, error } = await supabase.functions.invoke('resume-subscription')

  if (error) {
    console.error('Error resuming subscription:', error)
    throw new Error('Não foi possível reativar a assinatura.')
  }

  return data
}
